import { Component } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-pay-later-info',
  templateUrl: './pay-later-info.component.html',
  styleUrls: ['./pay-later-info.component.scss'],
  standalone: true,
})
export class PayLaterInfoComponent {
  public get phone(): string {
    return environment.phone;
  }
}
